import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { ProjectsAccessGuard } from 'modules/projects/components/ProjectsAccessGuard';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { homeRoutesConfig } from 'domains/home/routes';

import { useProjectsPageLoader } from '../../hooks';

const ProjectPage = loadable(
  async () => {
    const module = await import('./ProjectPage');

    return module.ProjectPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsPath = chainsRoutesConfig.chains.generatePath();
const homePath = homeRoutesConfig.home.generatePath();

function ProjectPageLoader() {
  const { isLoading, shouldForceRedirect } = useProjectsPageLoader({
    includeIsLoggedInInRedirect: true,
  });

  if (isLoading) {
    return <OverlaySpinner />;
  }

  return (
    <GuardAccountPermission
      permission={AccountPermission.UsageData}
      shouldForceRedirect={shouldForceRedirect}
      shouldHideAlert
      shouldRedirect
    >
      <ProjectsAccessGuard fallback={homePath}>
        <ProjectPage />
      </ProjectsAccessGuard>
    </GuardAccountPermission>
  );
}

// todo: refactor to remove unnecessary guards
export const ProjectPageContainer = () => {
  return (
    <Page>
      <NoSSRGuard>
        <LoggingInGuard fallback={<Navigate to={chainsPath} />}>
          <ProjectPageLoader />
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
